// 型号内联编辑表单组件
import React from 'react';
import { Save } from 'lucide-react';
import type { ProductModel } from '@/poster/types';

interface ModelInlineFormProps {
  formData: Partial<ProductModel>;
  setFormData: React.Dispatch<React.SetStateAction<Partial<ProductModel>>>;
  onSave: () => void;
  onCancel: () => void;
  isSaving: boolean;
}

export function ModelInlineForm({
  formData,
  setFormData,
  onSave,
  onCancel,
  isSaving,
}: ModelInlineFormProps) {
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">型号名称 *</label>
          <input
            type="text"
            value={formData.model_name || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, model_name: e.target.value }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="如: P0.9"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">像素间距 (mm)</label>
          <input
            type="number"
            step="0.1"
            value={formData.pitch || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, pitch: e.target.value ? parseFloat(e.target.value) : undefined }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="如: 0.9"
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">箱体尺寸</label>
          <input
            type="text"
            value={formData.cabinet_size || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, cabinet_size: e.target.value }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="如: 600×337.5mm"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">重量</label>
          <input
            type="text"
            value={formData.weight || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, weight: e.target.value }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="如: 8.5kg"
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">功耗</label>
          <input
            type="text"
            value={formData.power_consumption || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, power_consumption: e.target.value }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="如: 150W/㎡"
          />
        </div>
        <div className="flex items-end">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={formData.is_default || false}
              onChange={(e) => setFormData(prev => ({ ...prev, is_default: e.target.checked }))}
              className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <span className="text-sm text-gray-700">设为默认型号</span>
          </label>
        </div>
      </div>
      <div className="flex items-center gap-2 pt-2">
        <button
          onClick={onSave}
          disabled={isSaving || !formData.model_name}
          className="flex items-center gap-1 px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 disabled:opacity-50"
        >
          <Save className="w-4 h-4" />
          {isSaving ? '保存中...' : '保存'}
        </button>
        <button
          onClick={onCancel}
          className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-lg"
        >
          取消
        </button>
      </div>
    </div>
  );
}
